/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FromNowOrDateTimePipe } from '../pipes/from-now-or-date-time/from-now-or-date-time.pipe';
import { SortByNamePipe } from '../pipes/sort-by-name/sort-by-name.pipe';
import { EnabledDisabledPipe } from '../pipes/enabled-disabled/enabled-disabled.pipe';
import { LinebreakToBrPipe } from '../pipes/linebreak-to-br/linebreak-to-br.pipe';
import { LocationPipe } from '../pipes/location/location.pipe';
import { LinkyUnsanitizedPipe } from '../pipes/linky-unsanitized/linky-unsanitized.pipe';
import { ToNowPipe } from '../pipes/time/to-now/to-now.pipe';
import { FromNowPipe } from '../pipes/time/from-now/from-now.pipe';
import { EllipsizePipe } from '../pipes/ellipsize/ellipsize.pipe';
import { SortByOrderPipe } from '../pipes/sort-by-order/sort-by-order.pipe';
import { FormatPurchaseOrderManagerPipe } from '../pipes/names/format-purchase-order-manager/format-purchase-order-manager.pipe';
import { StripHtmlPipe } from '../pipes/strip-html/strip-html.pipe';
import { NumberToTimePipe } from '../+utils/number-to-time.pipe';
import { EscapeHtmlPipe } from '../pipes/escape-html/escape-html.pipe';
import { IsLinkPipe } from '../pipes/is-link/is-link.pipe';
import { TotalHoursAndMinutesPipe } from '../pipes/time/total-hours-and-minutes/total-hours-and-minutes.pipe';
import { UrlExternalizePipe } from '../pipes/url-externalize/url-externalize.pipe';
import { LinkyHTMLSanitizedPipe } from '../pipes/linky-sanitized/linky-sanitized.pipe';
import { CapitalizePipe } from '../pipes/capitalize/capitalize.pipe';
import { HumaneDatesPipe } from '../pipes/time/humane-dates/humane-dates.pipe';

/**
 * @deprecated This module is deprecated and should not be used.
 * Please import the individual pipes directly from their respective paths.
 */
@NgModule({
  imports: [
    CommonModule,
    LinkyHTMLSanitizedPipe,
    LinkyUnsanitizedPipe,
    FromNowPipe,
    LinebreakToBrPipe,
    EllipsizePipe,
    NumberToTimePipe,
    HumaneDatesPipe,
    EnabledDisabledPipe
  ],
  exports: [
    EnabledDisabledPipe,
    LinebreakToBrPipe,
    UrlExternalizePipe,
    LinkyHTMLSanitizedPipe,
    LinkyUnsanitizedPipe,
    LocationPipe,
    FormatPurchaseOrderManagerPipe,
    ToNowPipe,
    FromNowPipe,
    SortByNamePipe,
    EllipsizePipe,
    FromNowOrDateTimePipe,
    SortByOrderPipe,
    StripHtmlPipe,
    NumberToTimePipe,
    EscapeHtmlPipe,
    IsLinkPipe,
    TotalHoursAndMinutesPipe,
    CapitalizePipe,
    HumaneDatesPipe
  ],
  declarations: [
    UrlExternalizePipe,
    LocationPipe,
    FormatPurchaseOrderManagerPipe,
    ToNowPipe,
    SortByNamePipe,
    FromNowOrDateTimePipe,
    SortByOrderPipe,
    StripHtmlPipe,
    EscapeHtmlPipe,
    IsLinkPipe,
    TotalHoursAndMinutesPipe,
    CapitalizePipe,
  ]
})
export class NgFalconCommonModule {}
